import { Injectable, NgModule } from '@angular/core';

import { completeIconSet, PlIcon, plIcon } from '../icons';

@Injectable()
export class PlIconRegistry {
  private registry: Map<PlIcon, string> = new Map<PlIcon, string>();

  public registerIcons(icons: plIcon[]): void {
    icons.forEach((icon: any) => this.registry.set(icon.name, icon.data));
  }

  public getIcon(iconName: PlIcon): string {
    if (!this.registry.has(iconName)) {
      throw new Error(`👀 we could not find the Icon with the name ${iconName}, did you add it to the Icon registry?`);
    }
    return this.registry.get(iconName) as string;
  }
}

@NgModule({
  providers: [PlIconRegistry],
})
export class PlIconRegistryModule {
  constructor(private lavIconRegistry: PlIconRegistry) {
    this.lavIconRegistry.registerIcons(completeIconSet as plIcon[]);
  }
}
